/** In-memory active workspace org for API headers and non-React data hooks. */
let activeWorkspaceOrgId: string | null = null;

export function setActiveWorkspaceOrgId(orgId: string | null | undefined): void {
  activeWorkspaceOrgId = orgId?.trim() || null;
}

export function getActiveWorkspaceOrgId(): string | null {
  return activeWorkspaceOrgId;
}
